import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '400px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
}));

const ZombieTableColumns = () => {
  const classes = useStyles();

  return [
    { accessorKey: 'dealershipId', header: 'Dealership ID', minSize: 30, maxSize: 50, size: 50 },
    { accessorKey: 'departmentRoleId', header: 'Department Role ID', minSize: 30, maxSize: 50, size: 50 },
    { accessorKey: 'firstName', header: 'First Name', minSize: 80, maxSize: 100, size: 100 },
    { accessorKey: 'lastName', header: 'Last Name', minSize: 80, maxSize: 100, size: 100 },
    { accessorKey: 'primaryContactEmail', header: 'Primary Contact Email', minSize: 120, maxSize: 150, size: 150 },
    { accessorKey: 'timezone', header: 'Timezone', minSize: 80, maxSize: 100, size: 100 },
    {
      accessorKey: 'hash',
      header: 'Hash',
      minSize: 200,
      maxSize: 400,
      size: 400,
      Cell: ({ cell }) => <span className={classes.ellipsisMessage}>{cell.getValue()}</span>,
    },
    { accessorKey: 'enabled', header: 'Enabled', minSize: 30, maxSize: 50, size: 50 },
    { accessorKey: 'source', header: 'Source', minSize: 30, maxSize: 50, size: 50 },
    {
      accessorKey: 'lastSeen',
      header: 'Last Seen',
      minSize: 80,
      maxSize: 100,
      size: 100,
      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: 'lastActivity',
      header: 'Last Activity',
      minSize: 80,
      maxSize: 100,
      size: 100,
      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: 'createdAt',
      header: 'Created At',
      minSize: 80,
      maxSize: 100,
      size: 100,
      Cell: ({ cell }) => <span>{new Date(cell.getValue()).toLocaleDateString()}</span>,
    },
    {
      accessorKey: 'updatedAt',
      header: 'Updated At',
      minSize: 80,
      maxSize: 100,
      size: 100,
      Cell: ({ cell }) => <span>{new Date(cell.getValue()).toLocaleDateString()}</span>,
    },
    {
      accessorKey: 'enableAssign',
      header: 'Enable Assign',
      minSize: 30,
      maxSize: 50,
      size: 50,
    },
  ];
};

export default ZombieTableColumns;
